import type { AddressSearchType, AddressSearchTypeValue } from './types'
import { ALL_ADDRESS_SEARCH_TYPES } from './ALL_ADDRESS_SEARCH_TYPES'

// Exhaustive by type; (cities)/(regions) are Google collection tokens, not filterable types.
const NO_ADDRESS_MEMBERSHIP: Record<AddressSearchType, boolean> = {
  address: false,
  postcode: true,
  city: true,
  region: true,
  street: true,
  neighborhood: true,
  country: true,
  district: true,
  place: true,
  locality: true,
  block: true,
  '(cities)': false,
  '(regions)': false
}

function resolveMetaType(type: AddressSearchTypeValue): AddressSearchType[] {
  if (type === 'address-only') return ['address']
  if (type === 'no-address') {
    return ALL_ADDRESS_SEARCH_TYPES.filter((candidate) => NO_ADDRESS_MEMBERSHIP[candidate])
  }
  return [type]
}

export function resolveTypes(
  type: AddressSearchTypeValue | AddressSearchTypeValue[] | undefined
): AddressSearchType[] | undefined {
  if (type === undefined) return undefined
  const flat = Array.isArray(type) ? type : [type]
  return flat.flatMap(resolveMetaType)
}
